<article class="home-item">
  <div class="home-item__image-container">
    <img [src]="item.iconUrl" alt="">
  </div>
  <h1 class="home-item__title">{{item.title}}</h1>
  <ul class="home-item__links-list">
    <li *ngFor="let link of item.links">
      <a class="home-item__link" [routerLink]="link.url">{{link.label}}</a>
    </li>
  </ul>
  <a class="home-item__all-link" [routerLink]="item.viewAllUrl">View all</a>
</article>
